<div class="container">
    <h2>Task Execution Status</h2>
    <div>
        <table mat-table [dataSource]="devices" multiTemplateDataRows>
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let device">
                    @if(device.Status == teltonikaStates.success){
                    <mat-icon style="color:forestgreen"
                        [matTooltip]="'Success\nClick to view response'">check_circle</mat-icon>
                    }@else if(device.Status == teltonikaStates.failure){
                    <mat-icon style="color:crimson" [matTooltip]="'Failed\nClick to view response'">cancel</mat-icon>
                    }@else if(device.Status == teltonikaStates.loading){
                    <mat-spinner [diameter]="40"></mat-spinner>
                    }@else{
                    <mat-icon style="color:orange" [matTooltip]="'Cancelled'">cancel</mat-icon>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let device"> {{device.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Serial">
                <th mat-header-cell *matHeaderCellDef> Serial </th>
                <td mat-cell *matCellDef="let device"> {{device.Serial}} </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                    <div class="example-element-detail"
                        [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                        <div class="example-element-description">
                            @for(response of element.Responses; track response; let i= $index){
                            <div class="responses">
                                @if(response.ResponseCode!= null){
                                <div class="inline-data">
                                    <div class="response-code-container">
                                        <div class="number-label">{{i+1}}.</div>
                                        <div style="margin-right: 2%;"><b>Response Code: </b></div>
                                        <div>{{response.ResponseCode}}</div>
                                    </div>
                                </div>
                                }@if(response.Message != null){
                                <div
                                    [ngClass]="{'inline-data':true,'second-line-data':(!(response.Message!=null && response.ResponseCode== null))}">
                                    @if(response.Message!=null && response.ResponseCode== null){
                                    <div class="expanded-data-header"><b>{{i+1}}. Response Message: </b></div>
                                    <div>{{response.Message}}</div>
                                    }@else{
                                    <div><b>Response Message: </b></div>
                                    <div>{{response.Message}}</div>
                                    }

                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let device;columns: columnsToDisplay"
                [class.example-expanded-row]="expandedElement === device" (click)="expand(device)">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
        <div class="buttons">
            @if(isWebsocketClosed){
            <button mat-raised-button (click)="retryTask()">Retry<mat-icon>replay</mat-icon></button>
            }@else {
            <button mat-raised-button (click)="abortTask()">Abort Execution<mat-icon>stop_circle</mat-icon></button>
            }
            <button mat-raised-button (click)="close()">Exit<mat-icon>logout</mat-icon></button>
        </div>
    </div>
</div>